import type { ReactElement } from 'react';
import { CampaignPageEditor, CampaignPageList } from './CampaignPages.tsx';
import { WidgetEditor, WidgetList } from './Widgets.tsx';

export const CONTENT_PAGE_SHORTCUTS: [string, string][] = [
  ['g then q', 'Go to Campaign pages'],
  ['g then z', 'Go to Widgets'],
];

export function contentPage(path: string): ReactElement | null {
  if (path === '/campaign-pages') return <CampaignPageList />;
  if (path === '/campaign-pages/new') return <CampaignPageEditor campaignRef={null} />;
  const campaign = /^\/campaign-pages\/(evt_[A-Za-z0-9]+)$/.exec(path);
  if (campaign) return <CampaignPageEditor campaignRef={campaign[1]!} />;
  if (path === '/widgets') return <WidgetList />;
  if (path === '/widgets/new') return <WidgetEditor widgetRef={null} />;
  const widget = /^\/widgets\/(wdg_[A-Za-z0-9]+)$/.exec(path);
  return widget ? <WidgetEditor widgetRef={widget[1]!} /> : null;
}
